module.exports = __webpack_public_path__ + "static/media/swirepay-logowhite.bb80791a.svg";